export const startCase = (str?: string | null) => {
  if (!str) return '';

  return str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

const insertWordBoundaries = (input: string) => {
  return input
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]{2,})([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-zA-Z])(\d)/g, '$1 $2')
    .replace(/(\d)([a-zA-Z])/g, '$1 $2');
};

const toWords = (input?: string | null) => {
  if (!input) return '';

  const trimmed = `${input}`.trim();

  if (!trimmed) return '';

  const withoutLeadingUnderscores = trimmed.replace(/^_+/, '');

  if (!withoutLeadingUnderscores) return '';

  const withBoundaries = insertWordBoundaries(withoutLeadingUnderscores);
  const normalizedDelimiters = withBoundaries.replace(/[^\da-zA-Z]+/g, ' ');

  return normalizedDelimiters.trim().replace(/\s+/g, ' ');
};

export type HumanizeFormat = 'start-case' | 'sentence-case' | 'lower-case' | 'upper-case';

export type HumanizeOptions = {
  format?: HumanizeFormat;
};

const applyFormat = (value: string, format: HumanizeFormat) => {
  const normalizedValue = value.trim();

  switch (format) {
    case 'sentence-case': {
      const lower = normalizedValue.toLowerCase();

      return lower ? lower[0].toUpperCase() + lower.slice(1) : '';
    }

    case 'lower-case':
      return normalizedValue.toLowerCase();
    case 'upper-case':
      return normalizedValue.toUpperCase();
    case 'start-case':
    default:
      return startCase(normalizedValue.toLowerCase());
  }
};

export const humanize = (value: string, options?: HumanizeOptions) => {
  const { format = 'start-case' } = options ?? {};

  try {
    const words = toWords(value);

    if (!words) {
      const fallback = `${value ?? ''}`;

      return applyFormat(fallback, format);
    }

    return applyFormat(words, format);
  } catch {
    return value;
  }
};

export const camelToSnakeCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const splitCamelCaseToString = (s?: string) => {
  return s?.split(/(?=[A-Z])/)?.join(' ');
};
